import styled from 'styled-components';

const PageContainer = styled.div`
  width: 97%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
`;

const ChartsContainer = styled.div`
  width: 100 %;
  display: flex;
  wrap: wrap;
  @media (max-width: 1382px) {
    flex-direction: column;
  }
`;

export default {
  PageContainer,
  ChartsContainer,
};
